import { Typography } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { Workflow } from '@/types/workflows'
import DeleteConfirmDialog from '@/components/delete-confirm-dialog/DeleteConfirmDialog'

type DeleteWorkflowDialogProps = {
  overlay: OverlayState
  name: Workflow['name']
  onDelete: () => void
}

export default function DeleteWorkflowDialog({
  name,
  onDelete,
  overlay,
}: DeleteWorkflowDialogProps) {
  return (
    <DeleteConfirmDialog
      overlay={overlay}
      title="Delete Workflow"
      onDelete={onDelete}
      textToMatch={name}
      fieldLabel="Workflow Name"
    >
      <Typography>
        Deleting a workflow with workflow states will also delete those workflow
        states and other associated data.
      </Typography>
    </DeleteConfirmDialog>
  )
}
